import type { RecoilState } from "recoil"

import type { TransactionOperation } from "../../state/elements/transactions"

export const nextPlaybackStep: TransactionOperation<{
  getItems: TransactionOperation<undefined, unknown[][]>
  playbackState: RecoilState<[number, number]>
}> = (transactors, { getItems, playbackState }) => {
  const items = getItems(transactors)
  transactors.set(playbackState, ([i, j]): [number, number] => {
    const nextJ = j + 1
    if (nextJ >= items[i].length) {
      const nextI = i + 1 >= items.length ? 0 : i + 1

      return [nextI, 0]
    }

    return [i, nextJ]
  })
}

export const prevPlaybackStep: TransactionOperation<{
  getItems: TransactionOperation<undefined, unknown[][]>
  playbackState: RecoilState<[number, number]>
}> = (transactors, { getItems, playbackState }) => {
  const items = getItems(transactors)
  transactors.set(playbackState, ([i, j]): [number, number] => {
    const nextJ = j - 1
    if (nextJ < 0) {
      const nextI = i - 1 < 0 ? items.length - 1 : i - 1

      return [nextI, items[nextI].length - 1]
    }

    return [i, nextJ]
  })
}
